export type UserLoadedViewState =
  | 'loading'
  | 'error'
  | 'empty-team'
  | 'onboarding'
  | 'dashboard';

type ResolveUserLoadedViewStateArgs = {
  teamId: string | null | undefined;
  isFetchingTeam: boolean;
  teamQueryError: Error | null | undefined;
  isOnboarding: boolean;
  pathname: string;
  canAccessTeam: boolean | undefined;
};

export const resolveUserLoadedViewState = ({
  teamId,
  isFetchingTeam,
  teamQueryError,
  isOnboarding,
  pathname,
  canAccessTeam,
}: ResolveUserLoadedViewStateArgs): UserLoadedViewState => {
  if (!teamId) {
    if (teamQueryError) return 'error';
    if (isFetchingTeam) return 'loading';
    return 'empty-team';
  }

  if (isOnboarding && !pathname.startsWith('/settings')) return 'onboarding';
  if (canAccessTeam) return 'dashboard';
  if (teamQueryError) return 'error';
  return 'empty-team';
};
